import { ISceneFactory } from "./ISceneFactory";

export class SceneFactory {

    private static factories: {[path: string]: ISceneFactory} = {};

    public static registerScene(path: string, sceneFactory: ISceneFactory) {
        if (path == null) {
            throw new Error("The path param can not be null!");
        }
        if (sceneFactory == null) {
            throw new Error("The sceneFactory param can not be null!");
        }
        if (this.factories[path] != null) {
            throw new Error("A scene with the given path already exists: " + path);
        }

        this.factories[path] = sceneFactory;
    }

    public static getFactory(path: string): ISceneFactory {
        return this.factories[path];
    }

    private constructor() {}

}